import React, {useState, useRef} from 'react';
import {formatMessage} from "devextreme/localization";
import ValidationGroup from "devextreme-react/validation-group";
import {useFormData} from "../../utils/form-data";
import {SingleCard} from "../../layouts";
import {Alert, ParolaDegistir} from "../../components";

import {useAppState} from "../../contexts/app-state";
import notify from "devextreme/ui/notify";
import Button from "devextreme-react/button";

const errorsInit = () => ({ parolaYeni: false, parolaTekrar: false, message : false });
const createFormData = () => ({ parolaYeni: '', parolaTekrar: ''});

export default function ({ onSuccess, reason }) {
    const { state } = useAppState();
    const [error, setError] = useState(()=> errorsInit());
    const [isBusy, setIsBusy] = useState(false);
    const [validated, setValidated] = useState(false);
    const { formData, setInputValues } = useFormData(createFormData());
    const refValidationGroup = useRef(null);

    const sifreDegistir = (e) => {

        if (!validated) {
            return false;
        }

        setError(errorsInit());
        setIsBusy(true);

        const { parolaYeni, parolaTekrar } = formData;

        fetch("/ui/login/sifre-degistir",
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify( { parolaYeni, parolaTekrar } )
            })
            .then((response) => response.json())
            .then((res) => {
                if (res.success) {
                    onSuccess(res);
                } else {
                    setError(res.error);
                    setIsBusy(false);
                }
            })
            .catch((error) => {
                notify(formatMessage('oops'), "error", 2000);
                if (state.debug) {
                    console.error(error);
                }
                setIsBusy(false);
            });
    }

    const hataVar = error.message ? true : false;
    return <SingleCard disabled={isBusy}
                       hideFooter={true}
                       title={formatMessage('sifreDegistir.baslik')}
                       page="SayfaSifreDegistir">
        {hataVar && <Alert type="error"
                                 iconClass="fa fa-2x fa-exclamation-circle"
                                 message={error.message} />}
        {!hataVar && <Alert type="success"
                            message={reason}
                            iconClass="fa fa-2x fa-check-circle"  />}
        <div className={isBusy ? 'kq-progress-line' : 'kq-line'}/>
        <ValidationGroup ref={refValidationGroup}>
            <div className="kq-form">
                <p style={{textAlign:"center"}}>
                    {formatMessage('sifreDegistir.yeniSifreGir')}
                </p>
                <ParolaDegistir disabled={isBusy}
                                onValueChanged={(data) => {
                                    setInputValues({parolaYeni: data.parolaYeni, parolaTekrar: data.parolaTekrar});
                                    if (data.validated !== validated) {
                                        setValidated(data.validated);
                                    }
                                }}
                                buttonText="Değiştir"/>

                <br/>
                <Button width="100%"
                        type="success"
                        stylingMode="contained"
                        disabled={isBusy || !validated}
                        onClick={sifreDegistir}>
                    {formatMessage('kaydet')}
                </Button>
            </div>
        </ValidationGroup>
    </SingleCard>
}